var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountsSolid = function SvgAccountsSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 12a7 7 0 0 1-7 7c2 0 3.75-1.026 4.376-1.54v-.663A3.11 3.11 0 0 0 11.555 15H8.443a3.111 3.111 0 0 0-2.82 1.797v.664l.05.043A7 7 0 1 1 17 12ZM6.083 17.803C6.908 18.343 8.372 19 10 19a6.968 6.968 0 0 1-3.917-1.197ZM10 13.5A2.75 2.75 0 1 0 10 8a2.75 2.75 0 0 0 0 5.5Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 12,
    r: 7,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4.69c.36.297.694.633 1 1.003 1.237 1.497 2 3.546 2 5.808 0 2.26-.763 4.31-2 5.807-.306.37-.64.707-1 1.004",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgAccountsSolid;